import { createSlice } from "@reduxjs/toolkit";
import { CreativesSlice } from "types/campaign/creatives";
import { fetchCampaignCreatives } from "./thunk";

const initialState: CreativesSlice = {
    campaigns: {},
    loading: false,
    error: null,
}

const campaignCreatives = createSlice({
    name: 'campaignCreatives',
    initialState,
    reducers: {
        updateGallery: (state, action) => {
            state.campaigns[action.payload.campaignId] = { ...state.campaigns[action.payload], gallery: action.payload.gallery };
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCampaignCreatives.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCampaignCreatives.fulfilled, (state, action) => {
                state.campaigns[action.payload.campaignId] = { ...action.payload, last_fetched_at: Date.now() }
                state.loading = false;
                state.error = null;
            })
            .addCase(fetchCampaignCreatives.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to fetch campaign creatives"
            })
    }
})

export const { updateGallery } = campaignCreatives.actions;

export default campaignCreatives.reducer;